<ul class="nav-list">
  <ng-container *ngFor="let navigation of navigations; let navIdx = index">
    <li class="new-nav-item" *ngIf="navigation.Items && navigation.Items.length > 0">
      <hr *ngIf="navIdx === 0" class="header-divider" />
      <button
        type="button"
        class="new-nav-toggle"
        [attr.aria-haspopup]="true"
        [attr.aria-expanded]="expandedIndex === navIdx"
        [attr.aria-controls]="'panel-' + (navigation?.LevelIds?.TableId || navigation.Order || navIdx)"
        [attr.id]="'toggle-' + (navigation?.LevelIds?.TableId || navigation.Order || navIdx)"
        (click)="togglePanel(navIdx)"
        (keydown.enter)="togglePanelWithFocus(navIdx)"
        (keydown.space)="togglePanelWithFocus(navIdx); $event.preventDefault()"
      >
      <span
      *ngIf="shouldShowExpandIndicator(navigation, navIdx)"
      class="nav-item-right-indicator"
      aria-hidden="true"
    ></span>
        <span class="chevron" [class.expanded]="expandedIndex === navIdx" aria-hidden="true"></span>
        <span class="table-name">{{ navigation.Title }}</span>
      </button>
      <div
        class="new-nav-panel"
        [id]="'panel-' + (navigation?.LevelIds?.TableId || navigation.Order || navIdx)"
        [attr.aria-labelledby]="'toggle-' + (navigation?.LevelIds?.TableId || navigation.Order || navIdx)"
        [class.expanded]="expandedIndex === navIdx"
      >
          <ul class="new-sub-nav">
            <ng-container *ngFor="let item of navigation.Items; let subIdx = index">
              <li *ngIf="navigation.Items && navigation.Items.length >= 2 && subIdx === navigation.Items.length - 2 && item.Title === 'Imports'"
                  class="nav-divider-wrapper">
                <hr class="nav-divider" />
              </li>
              <li class="new-sub-item" [ngClass]="{ active: getRouterLink(item) === activeLink }">
                <a
                  *ngIf="(item.TableId || fromSameApp(item)) && !item.OpenNewWindow"
                  [routerLink]="getRouterLink(item)"
                  class="new-sub-link"
                  [attr.tabindex]="expandedIndex === navIdx ? null : -1"
                  [attr.aria-current]="getRouterLink(item) === activeLink ? 'page' : null"
                  title="{{ item.Title }}"
                >
                  {{ item.Title }}
                </a>
                <a
                  *ngIf="(!item.TableId && !fromSameApp(item)) && !item.OpenNewWindow"
                  href="javascript:void(0)"
                  class="new-sub-link"
                  [attr.tabindex]="expandedIndex === navIdx ? null : -1"
                  (click)="openLink(item)"
                  title="{{ item.Title }}"
                >
                  {{ item.Title }}
                </a>
                <button
                  *ngIf="item.OpenNewWindow"
                  type="button"
                  class="new-sub-link new-sub-link-button"
                  [attr.tabindex]="expandedIndex === navIdx ? null : -1"
                  (click)="openLinkInNewTab(item)"
                  (keydown.enter)="openLinkInNewTab(item)"
                  (keydown.space)="openLinkInNewTab(item); $event.preventDefault()"
                  title="{{ item.Title }}"
                >
                  {{ item.Title }}
                </button>
              </li>
              <li *ngIf="navigation.Items && navigation.Items.length >= 2 && subIdx === navigation.Items.length - 1 && navIdx !== navigations.length - 1">
                <hr style="margin: 0 0 0 0; border-top: 1px solid var(--border-primary);" />
              </li>

            </ng-container>
          </ul>
      </div>
    </li>
  </ng-container>
  <ng-content></ng-content>
</ul>

